import React, { useEffect } from "react";
import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider as PcConfigProvider } from "antd";
import { DEBUG_COMMON_KEY } from "@/modules/constant";
import { getLang, debounce, isH5, direction } from "@/modules/util";
import { ConfigProvider as H5ConfigProvider } from "antd-mobile";
import { I18nProvider, LOCALES } from "@/i18n";
import { antdLocalesMap } from "@/i18n/locale";
import enUS from "antd-mobile/es/locales/en-US";
import Loading from "@/component/Loading";
import { useState, Suspense, lazy } from "react";
import ThemeVariableProvider from "@/context/theme-variable-provider";
import { Helmet, HelmetProvider } from "react-helmet-async";
const HomePage = lazy(() => import("@/page/home"));
const NotFound = lazy(() => import("@/page/notFound"));

function App() {
  const [locale, setLocal] = useState(LOCALES.ENGLISH);
  const [className, setClassName] = useState(isH5() ? "app-h5" : "app-pc");
  useEffect(() => {
    if (window.location.search.includes("common=")) {
      const common = new URLSearchParams(window.location.search).get("common");
      if (common) localStorage.setItem(DEBUG_COMMON_KEY, common);
    }
    const lang = getLang();
    setLocal(lang);
  }, []);
  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setClassName(isH5() ? "app-h5" : "app-pc");
    }, 100);

    window.addEventListener("resize", debouncedHandleResize);

    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <html lang={locale} dir={direction} className={className} />
        </Helmet>
      </HelmetProvider>
      <PcConfigProvider locale={antdLocalesMap[locale]}>
        <H5ConfigProvider locale={enUS}>
          <I18nProvider locale={locale}>
            <ThemeVariableProvider>
              <Router>
                <Suspense fallback={<Loading />}>
                  <Routes>
                    <Route path="/:type/:token" element={<HomePage />}></Route>
                    <Route path="/*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </Router>
            </ThemeVariableProvider>
          </I18nProvider>
        </H5ConfigProvider>
      </PcConfigProvider>
    </>
  );
}

export default App;
